import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles'; // <-- IMPORTANTE
import CssBaseline from '@mui/material/CssBaseline';  // <-- IMPORTANTE

import theme from './theme'; // <-- IMPORTA O SEU NOVO TEMA

import MainLayout from './componentes/MainLayout';
import LoginPage from './componentes/login/Login';
import Dashboard from './componentes/Dashboard';
import Pacientes from './componentes/Pacientes';
import PacienteCadastro from './componentes/PacienteCadastro';
import FichaPaciente from './componentes/FichaPaciente';
import PsicologoCadastro from './componentes/PsicologoCadastro';
import Parametros from './componentes/Parametros';
import Financeiro from './componentes/Financeiro';
import ContasReceber from './componentes/ContasReceber';
import ContasReceberForm from './componentes/ContasReceberForm';
import ContasPagarForm from './componentes/ContasPagarForm';
import ContaBancariaForm from './componentes/ContaBancariaForm';
import ContasPagar from './componentes/ContasPagar';
import ContaBancaria from './componentes/ContaBancaria';
import PlanoPagamento from './componentes/PlanoPagamento';
import PlanoPagamentoForm from './componentes/PlanoPagamentoForm';
import AssinaturaPaciente from "./componentes/AssinaturaPaciente";
import PlanoAtendimento from './componentes/PlanoAtendimento';
import Periodicidade from './componentes/Periodicidade';
import GerarDocumentos from './componentes/GeradorDocumento';
import ParametrosContrato from './componentes/ParametrosContrato';
import AceiteEletronico from './componentes/AceiteEletronico';
import ConfirmacaoConsulta from './componentes/ConfirmacaoConsulta';
import RenovacaoAssinatura from './componentes/RenovacaoAssinatura';
import HistoricoDocumentos from './componentes/HistoricoDocumentos';
import HistoricoRenovacoes from './componentes/HistoricoRenovacoes';
import HistoricoFinanceiro from './componentes/HistoricoFinanceiro';
import Usuarios from './componentes/Usuarios';
import StatusSistema from './componentes/StatusSistema';
import AnexosPaciente from "./componentes/AnexosPaciente";
import Disponibilidade from './componentes/Disponibilidade';
import Calendario from './componentes/Calendario';
import FilaEsperaPage from './componentes/FilaEspera';
import PerfilUsuario from './componentes/PerfilUsuario';
import HistoricoNotificacoes from './componentes/HistoricoNotificacoes';
import Novidades from './componentes/Novidades';
import Anamnese from './componentes/Anamnese';
import AnamneseForm from './componentes/AnamneseForm';
import Prontuario from './componentes/Prontuario';
import ProntuarioForm from './componentes/ProntuarioForm';
import Sessoes from './componentes/Sessoes';
import SessaoForm from './componentes/SessaoForm';
import EvolucaoSessaoPage from './componentes/EvolucaoSessaoPage';
import Convenios from './componentes/convenios/Convenios';
import ConvenioForm from './componentes/convenios/ConvenioForm';
import ProcedimentosConvenio from './componentes/convenios/ProcedimentosConvenio';
import CarteirinhasPaciente from './componentes/convenios/CarteirinhasPaciente';
import Guias from './componentes/convenios/Guias';
import GuiaForm from './componentes/convenios/GuiaForm';
import Lotes from './componentes/convenios/Lotes';
import LoteDetalhe from './componentes/convenios/LoteDetalhe';
import Relatorios from './componentes/Relatorios';
import RelatorioViewer from './componentes/RelatorioViewer';
import RelatorioPersonalizado from './componentes/RelatorioPersonalizado';
import GraficosAtendimentos from './componentes/relatorios/GraficosAtendimentos';
import Backup from './componentes/Backup';
import { RELATORIOS } from './config/relatorios';
import { getSessionCookie, isAdmin } from './services/auth';

// --- 1. FUNÇÃO AUXILIAR DE VERIFICAÇÃO ---
const isAuthenticated = () => !!getSessionCookie();

// --- 2. ROTA PROTEGIDA (Login Obrigatório) ---
const RotaProtegida = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

const RotaPublica = ({ children }) => {
  if (isAuthenticated()) return <Navigate to="/dashboard" replace />;
  return children;
};

const RotaAdmin = ({ children }) => {
  if (!isAuthenticated()) return <Navigate to="/login" replace />;
  if (!isAdmin()) return <Navigate to="/dashboard" replace />;
  return children;
};


// Componentes temporários (mock)
const EmBreve = ({ title }) => <div style={{ padding: 20 }}><h2>{title}</h2><p>Em breve.</p></div>;

function App() {
  return (
      // ENVOLVER COM O THEME PROVIDER
      <ThemeProvider theme={theme}>
        {/* CssBaseline aplica as cores de fundo do tema e reseta as margens do navegador */}
        <CssBaseline />

        <BrowserRouter>
          <Routes>
            {/* Rotas públicas — sem login */}
            <Route path="/aceite/:token" element={<AceiteEletronico />} />
            {/* Confirmacao de consulta pelo paciente: publica, token na URL. */}
            <Route path="/confirmacao/:token" element={<ConfirmacaoConsulta />} />
            <Route path="/renovacao/:token" element={<RenovacaoAssinatura />} />

            <Route path="/login" element={<RotaPublica><LoginPage /></RotaPublica>} />

            <Route path="/" element={<RotaProtegida><MainLayout /></RotaProtegida>}>
              <Route index element={<Navigate to="/dashboard" replace />} />

              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/psicologos/novo" element={<PsicologoCadastro />} />
              
              {/* Rotas de Paciente */}
              <Route path="/pacientes" element={<Pacientes />} />
              <Route path="/pacientes/novo" element={<PacienteCadastro />} />
              {/* Ficha central do paciente (abas: resumo, atendimentos, clinico,
                  documentos, financeiro). Declarada antes de /pacientes/:id. */}
              <Route path="/pacientes/:id/ficha" element={<FichaPaciente />} />
              <Route path="/pacientes/:id" element={<PacienteCadastro />} />

              {/* Outras rotas do menu */}
              <Route path="/prontuarios" element={<Prontuario />} />
              <Route path="/prontuarios/novo" element={<ProntuarioForm />} />
              <Route path="/prontuarios/:id" element={<ProntuarioForm />} />
              <Route path="/anamnese" element={<Anamnese />} />
              <Route path="/anamnese/novo" element={<AnamneseForm />} />
              <Route path="/anamnese/:id" element={<AnamneseForm />} />
              <Route path="/sessoes" element={<Sessoes />} />
              <Route path="/sessoes/novo" element={<SessaoForm />} />
              <Route path="/sessoes/:id" element={<SessaoForm />} />
              <Route path="/sessoes/:id/evolucao" element={<EvolucaoSessaoPage />} />

              {/* Agendamentos */}
              <Route path="/agendamentos/calendario" element={<Calendario />} />
              <Route path="/agendamentos/disponibilidade" element={<Disponibilidade />} />
              <Route path="/agendamentos/fila-espera" element={<FilaEsperaPage />} />
              <Route path="/financeiro" element={<Financeiro />} />
              <Route path="/contas-receber" element={<ContasReceber />} />
              <Route path="/contas-receber/novo" element={<ContasReceberForm />} />
              <Route path="/contas-receber/:id" element={<ContasReceberForm />} />
              <Route path="/contas-pagar" element={<ContasPagar />} />
              <Route path="/contas-pagar/novo" element={<ContasPagarForm />} />
              <Route path="/contas-pagar/:id" element={<ContasPagarForm />} />
              {/* Convênios: cadastro, tabela de valores, guias e lotes de faturamento.
                  As rotas mais específicas vêm antes de /convenios/:id. */}
              <Route path="/convenios" element={<Convenios />} />
              <Route path="/convenios/novo" element={<ConvenioForm />} />
              <Route path="/convenios/:id/procedimentos" element={<ProcedimentosConvenio />} />
              <Route path="/convenios/:id" element={<ConvenioForm />} />
              <Route path="/pacientes/:id/convenios" element={<CarteirinhasPaciente />} />
              <Route path="/guias" element={<Guias />} />
              <Route path="/guias/novo" element={<GuiaForm />} />
              <Route path="/lotes-faturamento" element={<Lotes />} />
              <Route path="/lotes-faturamento/:id" element={<LoteDetalhe />} />

              <Route path="/relatorios" element={<Relatorios />} />
              {/* Antes das rotas por chave: "personalizado" não é chave de
                  relatório, e o catálogo não tem entrada com esse nome. */}
              <Route path="/relatorios/personalizado" element={<RelatorioPersonalizado />} />
              {/* Tambem antes das rotas por chave: "graficos" nao e chave do catalogo. */}
              <Route path="/relatorios/graficos" element={<GraficosAtendimentos />} />
              {/* Uma rota por relatório, geradas da mesma lista do hub e do menu:
                  relatório novo entra só em config/relatorios.js. */}
              {RELATORIOS.map(r => (
                  <Route
                      key={r.key}
                      path={`/relatorios/${r.key}`}
                      element={r.somenteAdmin
                          ? <RotaAdmin><RelatorioViewer reportKey={r.key} /></RotaAdmin>
                          : <RelatorioViewer reportKey={r.key} />}
                  />
              ))}
              <Route path="/parametros" element={<RotaAdmin><Parametros /></RotaAdmin>} />
              {/* O pacote leva o schema inteiro do consultório; a rota do
                  back-end também é hasRole("ADMIN"). */}
              <Route path="/backup" element={<RotaAdmin><Backup /></RotaAdmin>} />
              <Route path="/usuarios" element={<Usuarios />} />
              <Route path="/status-sistema" element={<StatusSistema />} />
              <Route path="/perfil" element={<PerfilUsuario />} />
              <Route path="/psicologo" element={<PsicologoCadastro />} />
              <Route path="/minha-conta" element={<EmBreve title="Minha Conta" />} />
              <Route path="/conta-bancaria" element={<ContaBancaria />} />
              <Route path="/conta-bancaria/nova" element={<ContaBancariaForm />} />
              <Route path="/conta-bancaria/:id" element={<ContaBancariaForm />} />
              <Route path="/plano-pagamento" element={<PlanoPagamento />} />
              <Route path="/plano-pagamento/novo" element={<PlanoPagamentoForm />} />
              <Route path="/plano-pagamento/:id" element={<PlanoPagamentoForm />} />
              <Route path="/financeiro/historico" element={<HistoricoFinanceiro />} />
              <Route path="/assinaturas-paciente" element={<AssinaturaPaciente />} />
              <Route path="/assinaturas-paciente/renovacoes" element={<HistoricoRenovacoes />} />
              <Route path="/planos-atendimento" element={<PlanoAtendimento />} />
              <Route path="/periodicidades" element={<Periodicidade />} />
              <Route path="/documentos/gerar" element={<GerarDocumentos />} />
              <Route path="/documentos/historico" element={<HistoricoDocumentos />} />
              {/* Modelos de documento são configuração do sistema: PATCH /parametros/modelos exige ADMIN. */}
              <Route path="/documentos/modelos" element={<RotaAdmin><ParametrosContrato /></RotaAdmin>} />
              <Route path="/pacientes/:id/anexos" element={<AnexosPaciente />} />
              <Route path="/notificacoes/historico" element={<RotaAdmin><HistoricoNotificacoes /></RotaAdmin>} />
              <Route path="/novidades" element={<Novidades />} />

            </Route>
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
  );
}

export default App;
